import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { GoldLoader } from '../shared/Loaders';

const AddEditGroupForm = () => {
  const { id } = useParams(); // for edit mode
  const navigate = useNavigate();
  const [groupName, setGroupName] = useState('');
  const [selectedCompetitions, setSelectedCompetitions] = useState([]);
  const [allCompetitions, setAllCompetitions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      fetchCompetitions(),
      id ? fetchGroupData() : Promise.resolve(),
    ]).finally(() => {
      if (!cancelled) setPageLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [id]);

  const fetchCompetitions = async () => {
    try {
      const res = await axios.get(`${API_URL}/Competitions`);
      setAllCompetitions(res.data || []);
    } catch (err) {
      console.error('Error loading Competitions:', err);
    }
  };

  const fetchGroupData = async () => {
    try {
      const res = await axios.get(`${API_URL}/groups/${id}`);
      const group = res.data;
      setGroupName(group.group_name);
      setSelectedCompetitions(group.competition_id.map(e => e._id));
    } catch (err) {
      console.error('Error loading group:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const groupData = {
      group_name: groupName,
      competition_id: selectedCompetitions
    };

    try {
      if (id) {
        await axios.put(`${API_URL}/groups/${id}`, groupData);
        alert('Group updated successfully');
      } else {
        await axios.post(`${API_URL}/groups`, groupData);
        alert('Group created successfully');
      }
      navigate('/groups/new');
    } catch (err) {
      console.error('Error saving group:', err);
      alert('Failed to save group');
    } finally {
      setLoading(false);
    }
  };

  const handleCompetitionselect = (competition) => {
    const value = competition.target.value;
    setSelectedCompetitions(prev =>
      prev.includes(value)
        ? prev.filter(id => id !== value)
        : [...prev, value]
    );
  };

  if (pageLoading) {
    return <GoldLoader label="Loading..." variant="page" />;
  }

  return (
    <div className="container mt-4">
      <h2>{id ? 'Edit' : 'Add'} Group</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Group Name</label>
          <input
            type="text"
            className="form-control"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Select Competitions</label>
          <div className="form-check">
            {allCompetitions.map(competition => (
              <div key={competition._id} className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`competition-${competition._id}`}
                  value={competition._id}
                  checked={selectedCompetitions.includes(competition._id)}
                  onChange={handleCompetitionselect}
                />
                <label className="edit-group form-check-label" htmlFor={`competition-${competition._id}`}>
                  {competition.competition_name}
                </label>
              </div>
            ))}
          </div>
        </div>

        <button type="submit" className="btn btn-warning" disabled={loading}>
          {loading ? 'Saving...' : id ? 'Update' : 'Create'}
        </button>
      </form>
    </div>
  );
};

export default AddEditGroupForm;
